/* eslint-disable @typescript-eslint/no-explicit-any */
import { TValidationResult } from 'FeatureModules/DataImport/types/dataImport.types';
import { Theme } from '@mui/material';
import { ColDef } from 'ag-grid-community';

export interface IExcelTableContext {
  theme: Theme;
  mode: 'view' | 'edit' | 'add-edit' | 'validation';
  isAppleDevice: boolean;
  columnDefs: TColDefWithValidator<any>[];
}

export type TSystemColumns = {
  validation: boolean;
  delete: boolean;
};

export const SYSTEM_COLUMN_KEYS = ['validation', 'delete'];

export type TValidatorFunction<ContextValues = any> = (
  newValue: string | undefined,
  columnValues: (string | undefined)[],
  context?: IExcelTableContext & ContextValues
) => TValidationResult;

export type TColDefWithValidator<
  TableColumnDef = unknown,
  ContextValues = unknown
> = ColDef<TableColumnDef> & {
  validator?: TValidatorFunction<ContextValues>;
  isRequired?: boolean;
};

export type TCellValue = string | number | Date | null;

export type TColumnDefinition<T extends TCellValue> = {
  id?: string;
  value?: T;
  isValid?: boolean;
  infoMessage?: string;
  warningMessage?: string;
  validationMessage?: string;
  errorMessage?: string;
  touched?: boolean;
};
